import React, {Component} from 'react';
import { Grid, Menu, Segment } from 'semantic-ui-react'
import ChangePassword from '../accounts/changePassword/changePasswordForm';
import UserBookmarks from '../userBookmarks/userBookmarks';

class UserDashboard extends Component {
	constructor(props) {
		super(props);
		this.state = {
			activeItem: 'My Bookmarks'
		};
		this.handleItemClick = this.handleItemClick.bind(this);
	}
	handleItemClick(e, { name })  {
		this.setState({ activeItem: name })

	}	
	
	render() {
		const { activeItem } = this.state
		return (
			<Grid>
			<Grid.Column width={4}>
			  <Menu fluid vertical tabular>
				<Menu.Item
				  name='My Bookmarks'
				  active={activeItem === 'My Bookmarks'}
				  onClick={this.handleItemClick}
				/>
				<Menu.Item
				  name='Change Password'
				  active={activeItem === 'Change Password'}
				  onClick={this.handleItemClick}
				/>
			
			  </Menu>
			</Grid.Column>
	
			<Grid.Column stretched width={12}>
				{activeItem == "Change Password" ? 
				<Segment><ChangePassword /></Segment>
				:
				<Segment>
				<UserBookmarks/>
			  </Segment>
				}
			</Grid.Column>
		  </Grid>
		);
	}
}


export default UserDashboard;
